import { FIND_LOG_RING_CAPACITY } from '../../config/findRemoteLogging';

function stablePayloadKey(payload) {
  try {
    return JSON.stringify(payload ?? {});
  } catch {
    return String(payload);
  }
}

export function collapseLogEntries(entries) {
  const collapsed = [];
  const indexByKey = new Map();

  for (const entry of entries) {
    const key = `${entry.level}|${entry.event_name}|${stablePayloadKey(entry.payload)}`;
    const existingIndex = indexByKey.get(key);
    if (existingIndex === undefined) {
      indexByKey.set(key, collapsed.length);
      collapsed.push({ ...entry });
      continue;
    }
    const existing = collapsed[existingIndex];
    existing.repeat_count = (existing.repeat_count ?? 1) + 1;
    existing.client_ts = entry.client_ts;
    existing.seq = entry.seq;
  }

  return collapsed;
}

export function createLogBuffer({ onPendingChange } = {}) {
  let entries = [];
  let nextSeq = 1;

  function notify() {
    onPendingChange?.(entries);
  }

  function trimRing() {
    if (entries.length <= FIND_LOG_RING_CAPACITY) {
      return;
    }
    entries = entries.slice(entries.length - FIND_LOG_RING_CAPACITY);
  }

  return {
    loadRestored(restoredEntries) {
      if (!Array.isArray(restoredEntries) || restoredEntries.length === 0) {
        return;
      }
      const maxSeq = restoredEntries.reduce((max, row) => (row.seq > max ? row.seq : max), 0);
      nextSeq = maxSeq + 1;
      entries = [...restoredEntries, ...entries];
      trimRing();
      notify();
    },

    append(entry) {
      const row = {
        ...entry,
        seq: nextSeq,
      };
      nextSeq += 1;
      entries.push(row);
      trimRing();
      notify();
      return row;
    },

    pendingCount() {
      return entries.length;
    },

    takeBatch(maxCount) {
      if (entries.length === 0) {
        return [];
      }
      const batch = entries.slice(0, maxCount);
      entries = entries.slice(batch.length);
      notify();
      return collapseLogEntries(batch);
    },

    prependRestored(restoredBatch) {
      if (!Array.isArray(restoredBatch) || restoredBatch.length === 0) {
        return;
      }
      entries = [...restoredBatch, ...entries];
      trimRing();
      notify();
    },

    peekAll() {
      return entries;
    },

    clear() {
      entries = [];
      nextSeq = 1;
      notify();
    },
  };
}
